<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <h4>{{ trans('general.component.notifications.title') }}</h4>
            <basic-button
                v-if="unread > 0"
                class="btn-success btn-ssm mb-2"
                :text="trans('general.component.notifications.mark_all_read')"
                icon="fi-rr-check"
                icon-position="right"
                style="height: 30px !important;"
                @click="markAllRead()"/>
        </template>
        <template #content>
            <div class="pb-4 mb-5 mb-lg-0" id="notifications">
                <NotificationTrayItem
                    v-for="(item, index) in items"
                    :key="index"
                    :item="item"
                    v-on:marked-read="markedRead($event)"/>

                <div class="mx-4">
                    <p class="text-center" v-if="items.length === 0">
                        {{ trans('general.component.notifications.no_notifications') }}</p>

                    <basic-button
                        ref="show_more"
                        v-if="showMoreBtn && items.length > 0"
                        :class="['mt-3 btn-fluid btn btn-primary btn-sm']"
                        :text="trans('general.component.notifications.show_more_notifications')"
                        @click="showMore()"/>
                </div>
            </div>
        </template>
    </slideout-content>
</template>

<script>
import NotificationTrayItem from "../atoms/NotificationTrayItem.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import SlideoutContent from "../../../theme/molecules/SlideoutContent.vue";

export default {
    name: "Notifications",
    components: {
        SlideoutContent,
        NotificationTrayItem,
        BasicButton,
    },
    props: {
        unread_count: Number,
        // load: Function,
        userId: String | Number,
        notifications: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            page: 1,
            limit: 7,
            items: [],
            unread: 0,
            types: {
                check_in: trans('general.module.notifications.type.check_in'),
                check_out: trans('general.module.notifications.type.check_out'),
                nap: trans('general.module.notifications.type.nap'),
                bathroom: trans('general.module.notifications.type.bathroom'),
                activity: trans('general.module.notifications.type.activity'),
                mood: trans('general.module.notifications.type.mood'),
                meal: trans('general.module.notifications.type.meal'),
                message: trans('general.module.notifications.type.message'),
                missing: trans('general.module.notifications.type.missing'),

            },
            showMoreBtn: true,
        }
    },
    methods: {
        setUnread(unread) {
            this.unread = unread;
        },
        setItems(items) {
            this.items = items;
        },
        load() {
            const params = {limit: this.limit, page: this.page};

            axios.get(`/notifications`, {params})
                .then((response) => {
                    let notices = response.data.data.notifications;

                    this.items = [...this.items, ...notices]

                    //modify check_out each item text
                    this.items.forEach((item, i) => {
                        if (item.data?.data?.type === 'check_out' && item.data?.data?.description != null) {
                            this.items[i].data.text = item.data.text +
                                ' (' + item.data.data.description + ')';
                        }
                    });

                    if (this.page === 1) {
                        this.unread = response.data.data.unreadCount;
                    }
                    if (notices.length < this.limit) {
                        this.showMoreBtn = false;
                    }
                });
        },

        showMore() {
            this.page = this.page + 1;
            this.load()
        },
        markAllRead() {
            axios.post(`/notifications/mark-read-all`)
                .then((response) => {
                    this.items = [];
                    this.load();
                    this.unread = 0;
                });
        },
        markedRead(event) {
            this.unread = this.unread > 0 ? this.unread - 1 : this.unread;
        },
        notify(title, data) {
            /*this.$notification.show(title, {body, icon: 'img/icon-128.png',
                vibrate: [100, 50, 100],
                data: {
                    dateOfArrival: Date.now(),
                    primaryKey: 1
                }}, {});*/
            try {
                if (((!this.$browserDetect.isIOS && !this.$browserDetect.isSafari) || this.$browserDetect.isChromeIOS) && location.pathname !== "/auth") {
                    if (Notification.permission === 'granted') {
                        navigator.serviceWorker.getRegistration().then(function (reg) {
                            let type = data.data.type === 'message' && !data.data.to ? "message-staff" : data.data.type;
                            let options = {
                                body: data.text,
                                icon: `/img/notifications/${type}.png`,
                                badge: '/img/notifications/badge-icon-org-128.png',
                                vibrate: [100, 50, 100],
                                data: {
                                    dateOfArrival: Date.now(),
                                    primaryKey: ""
                                },
                            };
                            if (data.data.images && data.data.images.length > 0) {
                                options.image = data.data.images[0].path
                            }
                            // reg.showNotification(title, options);
                        });
                    }
                }
            } catch (e) {
                console.log(e)
            }
            let audio = new Audio('/audio/notification.wav');
            audio.play();
        },
        closePanel(event) {
            event.preventDefault()
            this.markAllRead();
            this.$emit('closePanel', {
                unread: 0 //this.unread
            });
        },
    },
    mounted() {
        this.items = this.notifications;
        this.unread = this.unread_count !== '' && this.unread_count !== 0 ? this.unread_count : 0;
    }
}
</script>
